import { useCallback } from "react";
import { useDispatch, useSelector } from "../../redux/hooks";
import { setEngineSelectData } from "../../redux/slices/generatorFeaturesSlice";

/**
 * Hook to manage engine select data globally across components using Redux
 */
const useEngineSelectData = () => {
  const dispatch = useDispatch();
  const engineSelectData = useSelector(
    state => state.generatorFeaturesSlice.engineSelectData,
  );

  const updateEngineSelect = useCallback(
    (colIndex: number, value: string) => {
      dispatch(setEngineSelectData({ colIndex, value }));
    },
    [dispatch],
  );

  const getEngineSelectValue = useCallback(
    (colIndex: number): string => {
      const key = `engine${colIndex}`;
      return engineSelectData[key] || "";
    },
    [engineSelectData],
  );

  return {
    updateEngineSelect,
    getEngineSelectValue,
    engineSelectData,
  };
};

export default useEngineSelectData;
